import { render, staticRenderFns } from "./InputAddGrupoRolDialog.vue?vue&type=template&id=5405111d&"
import script from "./InputAddGrupoRolDialog.vue?vue&type=script&lang=js&"
export * from "./InputAddGrupoRolDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports